import { render, staticRenderFns } from "./ManageCustomPages.vue?vue&type=template&id=262c9b3a&scoped=true"
import script from "./ManageCustomPages.vue?vue&type=script&lang=js"
export * from "./ManageCustomPages.vue?vue&type=script&lang=js"
import style0 from "./ManageCustomPages.vue?vue&type=style&index=0&id=262c9b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c9b3a",
  null
  
)

export default component.exports